import { Icon } from '@components/index';

interface SandboxSwitchProps {
  isProfileList: boolean;
}

const SandboxSwitch = ({ isProfileList }: SandboxSwitchProps) => {
  const isSandBoxEnv = process.env.REACT_APP_ENVIRONMENT === 'sandbox';

  const onClickSwtichEnv = () => {
    if (isSandBoxEnv) window.open('https://web.cofee.life/', '_blank');
    else window.open('https://web.sandbox.cofee.life/', '_blank');
  };

  return (
    <div
      className={`ml-2 mr-1 flex cursor-pointer items-center rounded-md py-2.5 text-sm text-cofeeNeutral10 hover:bg-cofeeGreyBlue75 ${
        isProfileList ? 'gap-3 py-2.5 pl-3 pr-2' : '!ml-1 -mt-2 gap-3 px-4'
      }`}
      onClick={onClickSwtichEnv}
      role="presentation"
    >
      <Icon
        name="link"
        size="none"
        className={`size-5 ${
          isProfileList ? 'text-cofeeNeutral8' : 'text-cofeeNeutral10'
        }`}
      />
      <div>{isSandBoxEnv ? 'Production' : 'Sandbox'}</div>
    </div>
  );
};

export default SandboxSwitch;
